export default {
    email: {
      placeholder: "Inserisci l'email",
      label: "Email",
      validate: "Inserisci un'email valida"
    },
    password: {
      placeholder: "Inserisci la password",
      label: "Password",
      validate: "Inserisci una password valida"
    },
    confirmPassword: {
      placeholder: "Conferma la password",
      label: "Conferma Password",
      validate: "Le password devono coincidere"
    },
    username: {
      placeholder: "Inserisci il nome utente",
      label: "Nome Utente",
      validate: "Inserisci un nome utente valido"
    },
    phoneNumber: {
      placeholder: "Inserisci il numero di telefono",
      label: "Numero di Telefono",
      validate: "Inserisci un numero di telefono valido"
    },
    address: {
      placeholder: "Inserisci l'indirizzo",
      label: "Indirizzo",
      validate: "Inserisci un indirizzo valido"
    },
    city: {
      placeholder: "Inserisci la città",
      label: "Città",
      validate: "Inserisci una città valida"
    },
    zipCode: {
      placeholder: "Inserisci il CAP",
      label: "CAP",
      validate: "Inserisci un CAP valido"
    },
    country: {
      placeholder: "Inserisci il paese",
      label: "Paese",
      validate: "Inserisci un paese valido"
    },
    firstName: {
      placeholder: "Inserisci il nome",
      label: "Nome",
      validate: "Inserisci un nome valido"
    },
    lastName: {
      placeholder: "Inserisci il cognome",
      label: "Cognome",
      validate: "Inserisci un cognome valido"
    },
    dob: {
      placeholder: "Inserisci la data di nascita",
      label: "Data di Nascita",
      validate: "Inserisci una data di nascita valida"
    },
    gender: {
      placeholder: "Seleziona il genere",
      label: "Genere",
      validate: "Seleziona un genere valido"
    },
    nationality: {
      placeholder: "Inserisci la nazionalità",
      label: "Nazionalità",
      validate: "Inserisci una nazionalità valida"
    },
    occupation: {
      placeholder: "Inserisci l'occupazione",
      label: "Occupazione",
      validate: "Inserisci un'occupazione valida"
    },
    company: {
      placeholder: "Inserisci il nome dell'azienda",
      label: "Azienda",
      validate: "Inserisci un nome di azienda valido"
    },
    website: {
      placeholder: "Inserisci il sito web",
      label: "Sito Web",
      validate: "Inserisci un sito web valido"
    },
    bio: {
      placeholder: "Inserisci una breve biografia",
      label: "Biografia",
      validate: "Inserisci una biografia valida"
    },
    terms: {
      placeholder: "",
      label: "Accetto i termini e le condizioni",
      validate: "Devi accettare i termini e le condizioni"
    },
    newsletter: {
      placeholder: "",
      label: "Iscriviti alla newsletter",
      validate: ""
    },
    profilePicture: {
      placeholder: "Carica la foto profilo",
      label: "Foto Profilo",
      validate: "Carica una foto profilo valida"
    },
    submit: {
        placeholder: "",
        label: "Invia",
        validate: ""
    },
    reset: {
        placeholder: "",
        label: "Resetta",
        validate: ""
    },
    save: {
        placeholder: "",
        label: "Salva",
        validate: ""
    },
    delete: {
        placeholder: "",
        label: "Cancella",
        validate: ""
    },
    add: {
        placeholder: "",
        label: "Aggiungi",
        validate: ""
    },
    required: "Campo obbligatorio",
}
  